// extracted by mini-css-extract-plugin
export default {"holder":"wrapper_holder__fx14y"};